import styled, { css } from "styled-components";
import { CoreAlertModal, type AlertSeverity } from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

import { ContainerBase } from "../Modal/Modal.styled";

export const Container = styled(ContainerBase)`
  display: grid;
  grid-template-rows: auto 1fr auto;
`;

type HeaderProps = {
  $severity: AlertSeverity;
};
export const Header = styled.div<HeaderProps>`
  ${({ $severity }) => {
    const { tokens } = useDesignTokens();
    const { modal, alertModal } = tokens;

    return css`
      display: grid;
      border-top-width: ${alertModal.stroke.top.width};
      border-top-style: ${alertModal.stroke.top.style};
      border-top-color: ${alertModal.stroke.top.color[$severity]};
      padding-top: ${alertModal.padding.mobile.top};
      padding-left: ${alertModal.padding.mobile.left};
      padding-right: ${alertModal.padding.mobile.right};

      padding-bottom: ${alertModal.header.padding.bottom};
      gap: ${alertModal.header.gap};

      @media (min-width: ${modal.breakpoints.tablet}) {
        padding-top: ${alertModal.padding.tablet.top};
        padding-left: ${alertModal.padding.tablet.left};
        padding-right: ${alertModal.padding.tablet.right};
      }
    `;
  }}
`;

type IconWrapperProps = {
  $severity: AlertSeverity;
};

export const IconWrapper = styled.div<IconWrapperProps>`
  ${({ $severity }) => {
    const { tokens } = useDesignTokens();
    const { alertModal, modal } = tokens;

    return css`
      svg {
        display: block;
        width: ${alertModal.icon.width.mobile};
        height: ${alertModal.icon.height.mobile};

        & [data-primary-color] {
          color: ${alertModal.icon.primaryColor[$severity]};
        }

        & [data-secondary-color] {
          color: ${alertModal.icon.secondaryColor[$severity]};
        }
      }

      @media (min-width: ${modal.breakpoints.tablet}) {
        svg {
          width: ${alertModal.icon.width.tablet};
          height: ${alertModal.icon.height.tablet};
        }
      }
    `;
  }}
`;

type BodyProps = {
  $stickFooter: boolean;
};
export const Body = styled.div<BodyProps>`
  ${({ $stickFooter }) => {
    const { tokens } = useDesignTokens();
    const { alertModal, modal } = tokens;

    return [
      css`
        color: ${alertModal.body.color};

        padding-left: ${alertModal.padding.mobile.left};
        padding-right: ${alertModal.padding.mobile.right};

        @media (min-width: ${modal.breakpoints.tablet}) {
          padding-left: ${alertModal.padding.tablet.left};
          padding-right: ${alertModal.padding.tablet.right};
        }
      `,
      $stickFooter
        ? css`
            padding-bottom: ${alertModal.body.padding.withStickyFooter.bottom};
          `
        : css`
            padding-bottom: ${alertModal.body.padding.default.bottom};
          `,
    ];
  }}
`;

type FooterProps = {
  $layout: CoreAlertModal.FooterLayout;
  $stickFooter: boolean;
};

export const Footer = styled.div<FooterProps>`
  ${({ $layout, $stickFooter }) => {
    const { tokens } = useDesignTokens();
    const { alertModal, modal } = tokens;

    return [
      css`
        gap: ${alertModal.footer.gap};
      `,
      $layout === "inline" &&
        css`
          display: inline-grid;
          grid-auto-flow: column;
        `,
      $layout === "stacked" &&
        css`
          display: grid;
          grid-auto-flow: row;
        `,
      css`
        padding-left: ${alertModal.padding.mobile.left};
        padding-right: ${alertModal.padding.mobile.right};
        padding-bottom: ${alertModal.padding.mobile.bottom};

        @media (min-width: ${modal.breakpoints.tablet}) {
          padding-left: ${alertModal.padding.tablet.left};
          padding-right: ${alertModal.padding.tablet.right};
          padding-bottom: ${alertModal.padding.tablet.bottom};
        }
      `,
      $stickFooter &&
        css`
          padding-top: ${alertModal.footer.sticky.padding.top};
          padding-bottom: ${alertModal.footer.sticky.padding.bottom};
          @media (min-width: ${modal.breakpoints.tablet}) {
            padding-top: ${alertModal.footer.sticky.padding.top};
            padding-bottom: ${alertModal.footer.sticky.padding.bottom};
          }
        `,
    ];
  }}
`;
